import { IIndexable } from "@customtypes/common";

export const descriptionMappings: IIndexable = {
  BNB: "BNB Staking - Stake & earn rewards with BNB Staking. Access binance staking across the BNB ecosystem with Stader Labs.",
  POLYGON:
    "Polygon Staking - Stake & earn rewards with polygon liquid matic staking. Access matic staking across the Polygon ecosystem with Stader Labs.",
  ETH: "Ethereum Staking - Stake Ether with Stader & earn rewards. Earn Eth2 rewards across Ethereum ecosystem.",
};

export const titleMappings: IIndexable = {
  BNB: "BNB Staking - Earn Liquid Binance Staking Rewards | Stader Labs",
  POLYGON: "Polygon Staking - Earn Liquid Matic Staking Rewards | Stader Labs",
  ETH: "Ethereum Staking - Stake Ether & Earn Eth2 Rewards | Stader Labs",
};

export const keyWordsMapping: IIndexable = {
  BNB: "bnb staking, binance staking, crypto binance, binance staking rewards",
  ETH: "ether staking, eth2 staking rewards, eth2 staking",
};

export const headingMappings: IIndexable = {
  BNB: "Binance Staking | BNB",
  ETH: "Ethereum Staking | Eth2 Rewards",
};
